import { createSelector } from 'reselect'

import { getClientIdFromBearerToken } from '../../auth'
import { selectClientId } from './client'

export const selectAuthedAsClient = createSelector(
  selectClientId,
  clientId => getClientIdFromBearerToken() === clientId
)
